import React, { useState } from 'react';
import { RichTextEditor } from 'common/RichTextFormat/editor/RichTextEditor';
import { resolveStyledFieldName } from 'common/RichTextFormat/viewer/TextFieldResolver';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';

export default function EditCustomFieldModal({ originalCustomFieldName, styledFieldName, isStyled, onSave, modalBox }) {
  const [state, setState] = useState({
    originCustomFieldName: originalCustomFieldName,
    updatedCustomFieldName: originalCustomFieldName,
    originalStyledFieldName: styledFieldName,
    updatedStyledFieldName: styledFieldName,
    isStyled: isStyled
  });

  return (
    <>
      <ModalBoxes.Header>Edit Custom Field</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="col-12 form-row p-0 m-0 mt-3">
          <label htmlFor="updatedCustomFieldName">New Custom Field Name</label>
          {state.isStyled ? (
            <RichTextEditor
              className={'regular-item-group'}
              onChange={(htmlString, rawTextString) => onChangeStyledCustomFieldName(htmlString, rawTextString)}
              value={resolveStyledFieldName(state.originalStyledFieldName, state.originCustomFieldName)}
            />
          ) : (
            <textarea
              rows="1"
              id="updatedCustomFieldName"
              value={state.updatedCustomFieldName}
              onChange={event => onChangeCustomFieldName(event)}
              className=" form-control"
            />
          )}
        </div>
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            Cancel
          </Button>
          <Button
            onClick={function() {
              onSave({
                updatedCustomFieldName: state.updatedCustomFieldName,
                updatedStyledFieldName: state.updatedStyledFieldName
              });
            }}
            disabled={isFieldNameNotUpdated()}
          >
            Update
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );

  function onChangeCustomFieldName(e) {
    if (e.target.value?.length <= 2000) {
      setState(prevState => ({
        ...prevState,
        updatedCustomFieldName: e.target.value
      }));
    }
  }

  function onChangeStyledCustomFieldName(htmlString, rawTextString) {
    if (state.isStyled) {
      setState(prevState => ({
        ...prevState,
        updatedCustomFieldName: rawTextString,
        updatedStyledFieldName: htmlString
      }));
    }
  }

  function isFieldNameNotUpdated() {
    if (!state.updatedCustomFieldName.trim()) {
      return true;
    }
    if (state.isStyled) {
      return state.originalStyledFieldName === state.updatedStyledFieldName;
    } else {
      return state.originCustomFieldName === state.updatedCustomFieldName;
    }
  }
}

EditCustomFieldModal.className = 'element-setup-modals';
EditCustomFieldModal.size = 'w650';
